export default __webpack_public_path__ + "static/media/ic_mali.a3496338.svg";